import { createSelector } from "reselect";

import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";
import type { RootState } from "single-spa/store/types";

import { selectSalesIntelligenceState } from "../../../store/selectors";

import { ContactsAvailabilityStatus } from "./types";

const select = createStatePropertySelector(selectSalesIntelligenceState("contactsExport"));

const selectContactsStatus = select("contactsStatus");
export const selectContactsAdmins = select("contactsAdmins");
export const selectLoadingContactStatus = select("loadingContactsStatus");
export const selectIsContactsStatusFetched = select("isContactsStatusFetched");

const selectContactsAvailability = (state: RootState) => {
    return selectContactsStatus(state)?.availability;
};

export const selectIsContactsDisabledByAccount = createSelector(
    selectContactsAvailability,
    (availability) => availability === ContactsAvailabilityStatus.DisabledByAccount,
);

export const selectIsContactsDisabledByCountry = createSelector(
    selectContactsAvailability,
    (availability) => availability === ContactsAvailabilityStatus.DisabledByCountry,
);

export const selectIsContactsPendingApproval = createSelector(
    selectContactsAvailability,
    (availability) => availability === ContactsAvailabilityStatus.PendingApproval,
);

export const selectIsContactsReadonly = createSelector(
    selectContactsAvailability,
    (availability) => availability === ContactsAvailabilityStatus.Readonly,
);

export const selectIsContactsFullAccess = createSelector(
    selectContactsAvailability,
    (availability) => availability === ContactsAvailabilityStatus.FullAccess,
);

const selectIsContactsDisabled = createSelector(
    selectContactsAvailability,
    (availability) =>
        availability === ContactsAvailabilityStatus.DisabledByAccount ||
        availability === ContactsAvailabilityStatus.DisabledByCountry,
);

export const selectIsContactsVisible = createSelector(
    selectContactsAvailability,
    (availability) =>
        availability === ContactsAvailabilityStatus.FullAccess ||
        availability === ContactsAvailabilityStatus.Readonly ||
        availability === ContactsAvailabilityStatus.PendingApproval,
);

export const selectHasRevealedContacts = createSelector(selectContactsStatus, (status) => status.hasRevealedContacts);
